import { Injectable } from '@angular/core';
import { JwtHelper } from 'angular2-jwt';
import { Observable } from 'rxjs/Observable';
// tslint:disable-next-line:import-blacklist
import 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { CognitoUtil, UserLoginService, UserParametersService } from './cognito.service';
import { BackEndRegistration } from '../index';
import { environment } from '../../../environments/environment';
import { GlobalEventsManager } from '../../app-global-events-manager';
import { BlockingProxy } from 'blocking-proxy';

@Injectable()
export class AuthService {

    // API Link
    public static _BACKEND_API_LINK = environment.backendapi;
    headers: Headers;
    options: RequestOptions;
    // tslint:disable-next-line:no-inferrable-types
    authenticated: boolean = false;

    constructor(public router: Router, private cognito: CognitoUtil, private userServices: UserLoginService,
        private http: Http, private globalEventsManager: GlobalEventsManager,
        public userParameterService: UserParametersService) {
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.options = new RequestOptions({ headers: this.headers });
    }

    public getProfile() {
        return this.cognito.getCurrentUser();
    }

    public isAuthenticated(): Promise<boolean> {
        // Check whether the current time is past the
        // access token's expiry time
        return this.retrieveAccessToken()
            .then(token => {
                const jwtHelper = new JwtHelper();
                this.authenticated = token !== null && !jwtHelper.isTokenExpired(token);
                return this.authenticated;
            })
            .catch(() => {
                this.authenticated = false;
                return this.authenticated;
            });
    }
    // get the Role Of the User
    public getLoggedInUser(): Promise<any> {
        return this.retrieveAccessParameters()
            .then(result => {
                if (result != null) {
                    if (result.length > 0) {
                        // tslint:disable-next-line:prefer-const
                        let roleObj = {Name: '', Value: ''};
                        result.map(function (ite) {
                            if (ite.Name === 'custom:role') {
                                roleObj = ite;
                            }
                        });
                        if (roleObj != null) {
                            return { role: roleObj.Value };
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            })
            .catch(() => {
                return null;
            });

        // return this.userParameterService.getParameters(this);
    }
    // // Call Back Functions for Parameter Service
    // callbackWithParam(result: any) {
    //     if (result != null) {
    //         if (result.lenth > 0) {
    //             // tslint:disable-next-line:prefer-const
    //             let roleObj = result.map(function (ite) {
    //                 if (ite.Name === 'custom:role') {
    //                     return ite;
    //                 }
    //             });
    //             if (roleObj != null) {
    //                 return { role: roleObj.Value };
    //             } else {
    //                 return null;
    //             }
    //         } else {
    //             return null;
    //         }
    //     } else {
    //         return null;
    //     }
    // }

    public retrieveIdToken() {
        return this.cognito.getIdToken();
    }

    public retrieveAccessToken() {
        return this.cognito.getAccessToken();
    }

    public retrieveAccessParameters() {
        return this.cognito.getAccessParameters();
    }
    // Validate the Token
    isValidToken(access_token): boolean {
      const jwtHelper = new JwtHelper();
      // tslint:disable-next-line:prefer-const
      let returnValue = access_token !== null && !jwtHelper.isTokenExpired(access_token);
      return returnValue;
    }

    public logout() {
        // localStorage.removeItem(`${BOX_CONFIG.boxTokenStorageKey}.${this.getProfile().username}`);
        this.globalEventsManager.showNavBar(false);
        this.userServices.logout();
        this.router.navigate(['/login']);
    }

    // Registration with Back end service
    public backEndRegistration(backuser: BackEndRegistration): Observable<any> {
        // tslint:disable-next-line:prefer-const
        let body = JSON.stringify(backuser);
        return this.http.post(AuthService._BACKEND_API_LINK + '/seller_registration', body, this.options)
            .map(this.extractRequests)
            .catch(this.handleError);
    }
    // Check email exist or not
    public checkUserNameExitsOrNot(username: string): Observable<any> {
        return this.http.get(AuthService._BACKEND_API_LINK + '/email_exist/' + username, this.options)
            .map(this.extractRequests)
            .catch(this.handleError);

    }
    public confirmEmailVerification(username: string, verification_code: string): Observable<any> {
        return this.http.get(AuthService._BACKEND_API_LINK + '/email_verification/' + username + '/' + verification_code, this.options)
            .map(this.extractRequests)
            .catch(this.handleError);

    }

    public resendEmailVerification(username: string): Observable<any> {
        return this.http.get(AuthService._BACKEND_API_LINK + '/resend_confirmation_code/' + username, this.options)
            .map(this.extractRequests)
            .catch(this.handleError);

    }


    // Activate the User After Verification Code verify
    public active_User(username: string): Observable<any> {
        return this.http.get(AuthService._BACKEND_API_LINK + '/activate_user/' + username, this.options)
            .map(this.extractRequests)
            .catch(this.handleError);
    }

    // Company Registration Number Validation
    public getbussinessInfomation(businessid: string): Observable<any> {
        return this.http.get(AuthService._BACKEND_API_LINK + '/get_business_info/' + businessid, this.options)
            .map(this.extractRequests)
            .catch(this.handleError);
    }

    // Response split
    private extractRequests(res: Response) {
        if (res['_body']) {
            const data = JSON.parse(res['_body']);
            if (data != null && data.value) { return data.value; }
            // tslint:disable-next-line:one-line
            else { return data; }
        }
    }
    // Error Handler
    private handleError(error: Response | any) {
        // check JWT expired error - if expired refresh page, this'll redirect to login automatically by auth guard
        if (error.message === 'No JWT present or has expired') {
            location.reload();
        }

        let errMsg: string;
        if (error instanceof Response) {
            // const body = error.json() || '';
            const err = JSON.stringify(error);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        // console.error(errMsg);
        return Observable.throw(errMsg);
    }

}



// WEBPACK FOOTER //
// ./src/app/authentication/service/auth.service.ts